module.exports = __webpack_public_path__ + "static/media/logo3.a693907a.png";